import { HeroHeader } from "../../components/HeroHeader";
import { Stack } from "../../components/Stack";
import { PageShell } from "../../components/PageShell";
import { Seo } from "../../components/Seo";
import { useInitApp } from "../../hooks/useInitApp";
import { useSelector } from "react-redux";
import { selectAllContent } from "../../features/apartments/selectors";
import { imagesResponse } from "../../api/responses";
import { useTranslation } from "react-i18next";
import cofinancedImage from "../../assets/PaginaWeb.png";
import "./style.css";
import { useEffect } from "react";
import { initFadeInAnimation } from "../../animation";
import "../HomePage/style.css";

export const CofinancedProjects = () => {
  useInitApp();
  const content = useSelector(selectAllContent);
  const { t } = useTranslation();

  useEffect(() => {
    initFadeInAnimation(".fade-in");
  }, []);

  return (
    <>
      <Seo
        title="Progetti cofinanziati"
        description="Progetti cofinanziati di Isola Dei Mori."
      />
      <PageShell>
        <HeroHeader
          title={t("progetti-cofinanziati") || "Progetti cofinanziati"}
          imgSrc={content?.[4]?.url || imagesResponse[0].url}
          className="fade-in"
        />
        <Stack flexDirection="column">
          <div className="first-home">
            <div className="text-container-centered cofinanced-centered">
              <img
                src={cofinancedImage}
                alt="Progetti cofinanziati"
                className="cofinanced-svg"
              />
              <p className="cofinanced-description">
                Intervento di ammodernamento di una struttura ricettiva
                extra-alberghiera a Sant’Antioco, località Calasapone,
                finalizzato a migliorare l’esperienza degli ospiti e a rendere
                l’attività più sostenibile ed efficiente. Il progetto è
                realizzato con il contributo delle risorse nazionali della
                coesione – FSC Fondo per lo Sviluppo e la Coesione 2021-2027.
              </p>
            </div>
          </div>
        </Stack>
      </PageShell>
    </>
  );
};
